import * as React from 'react';
import type { SVGProps } from 'react';
const IconEmphasis = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconEmphasis"
    role="presentation"
    {...props}
  >
    <path fill="currentColor" d="M18 6H8v2h10zM20 11H8v2h12zM18 16H8v2h10z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 19h2V5H4z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconEmphasis;
